import debug from 'debug';

// Add your logger here to make it show up in the dev panel for easy toggling
// The value is whether it will be on by default or not
const loggers = {
  'aha-editor:plugins': true,
  'aha-board:AhaBoardMeasurer': false,
  'aha-board:AhaBoardView:detectionRect': false,
  'aha-board:AhaBoardView:measuredItems': false,
  'aha-board:AhaBoardView:visibleItems': false,
  'aha-board:getVisibleGroups': false,
  'aha-board:GroupContentLoader': false,
  'aha-board:useVisibleBoard:detection': false,
  'aha-board:CardView': false,
  analytics: true,
  'app:components:page_tree:PageHierarchy': true,
  'framework:reactive-model-registry': false,
  'framework:routing': true,
  'framework:controller:subscriptions': true,
  gantt: true,
  'gantt:controller:reactions': false,
  keybindings: true,
  'mvc:controller:actions': true,
  reactive_rails: false,
  'reactive-register': false,
  'reactive-update-request': false,
  'retrospective_report:parseRecordData': false,
  'slate-collaboration:collaboration': false,
  'slate-collaboration:history': false,
  'slate-collaboration:presence': false,
  'slate-collaboration:selection-synchronizer': false,
  whiteboard: true,
  'whiteboard:ado': false,
  'whiteboard:analytics': false,
  'whiteboard:assistant': true,
  'whiteboard:client': false,
  'whiteboard:clientOps': false,
  'whiteboard:fuzzer': false,
  'whiteboard:testHelpers': false,
  'whiteboard:ui': true,
  'whiteboard:undo': false,
  'whiteboard:undoStack': false,
};

// Simple pass through to debug with a safety ceck
function makeDebugger(loggerName) {
  if (!loggers.hasOwnProperty(loggerName)) {
    console.error('There is no debugger registered for', loggerName);
  }

  return debug(loggerName);
}

export { makeDebugger as default, loggers };
